module.exports = __webpack_public_path__ + "static/media/isActiveButton.aa674a3c.svg";